var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackageDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50001 7.66938V6.69938C7.50001 4.44938 9.31001 2.23938 11.56 2.02938C12.1852 1.96795 12.8163 2.0381 13.4127 2.23531C14.0091 2.43252 14.5577 2.75242 15.023 3.17442C15.4883 3.59642 15.8602 4.11117 16.1145 4.68555C16.3689 5.25992 16.5002 5.88119 16.5 6.50938V7.88938M9.00001 21.9994H15C19.02 21.9994 19.74 20.3894 19.95 18.4294L20.7 12.4294C20.97 9.98938 20.27 7.99938 16 7.99938H8.00001C3.73001 7.99938 3.03001 9.98938 3.30001 12.4294L4.05001 18.4294C4.26001 20.3894 4.98001 21.9994 9.00001 21.9994Z",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.495 12H15.505M8.495 12H8.503",
    stroke: "#0061AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageDash);
export default __webpack_public_path__ + "static/media/package_dash.f1de875c92566269137b1865ee1f8d12.svg";
export { ForwardRef as ReactComponent };